<template>
  <div>
    <div class="doctor-info">
      <!-- Nombre completo -->
      <header>
        {{ doctor && doctor.prename }}
        {{ doctor.fname }} {{ doctor.mname }}
        {{ doctor.lname }} {{ doctor.llname }}
        {{ doctor && doctor.posname }}
      </header>
      <!-- Especialidades -->
      <p>
        <span
          v-for="(degree, index) in doctor.degrees"
          :key="index"
          class="auto-coma auto-punto-final"
        >
          {{ degree.name }}
        </span>
      </p>
      <!-- Dirección: País, Estado, Ciudad. -->
      <p v-if="doctor.works_at.length">
        {{
          doctor.works_at[0].in.location.address.city.state.country.name
        }},
        {{
          doctor.works_at[0].in.location.address.city.state.name
        }},
        {{
          doctor.works_at[0].in.location.address.city.name
        }}.
      </p>
      <p v-else>
        No ha registrado lugares de trabajo.
      </p>
      <p class="status">
        {{ userStatus[status] }}
      </p>
      <p class="creacion">
        {{ fecha.formatted }}
      </p>
    </div>
    <slot name="botones" />
  </div>
</template>
<script>
export default {
  name: 'TarjetaResultadoMedico',
  props: {
    doctor: {
      type: Object,
      default: function() {
        return {
          degrees: [{career: {tags: []}}],
        };
      },
    },
    status: {
      type: String,
      required: true,
    },
    fecha: {
      type: Object,
      default: function() {
        return {
          formatted: '',
        };
      },
    },
  },
  data() {
    return {
      userStatus: {
        Preaprobado: 'Pre aprobado',
        emailConfirmation: 'Sin confirmación de email',
      },
    };
  },
};
</script>
<style lang="scss">
  .doctor-info {
    p {
      margin-bottom: 0;
    }
    .status {
      font-size: .8rem;
      font-weight: 600;
      text-transform: uppercase;
    }
  }
</style>
